function saveActiveTab(sectionId, groupId) {
  try {
    localStorage.setItem('activeTab_' + sectionId, groupId);
  } catch (e) {
    console.error('Error saving to localStorage', e);
  }
}

function getActiveTab(sectionId) {
  try {
    return localStorage.getItem('activeTab_' + sectionId);
  } catch (e) {
    console.error('Error retrieving from localStorage', e);
    return null;
  }
}

function initPopupFunctionality() {
  const iconImage = document.querySelector('.eva-icon-pdp');
  const modalDialog = document.getElementById('PopupModal-Fabric');
  const closeModal = document.getElementById('ModalClose-Fabric');

  if (iconImage && modalDialog) {
    iconImage.removeEventListener('click', openModal);
    iconImage.addEventListener('click', openModal);
  }

  if (closeModal && modalDialog) {
    closeModal.removeEventListener('click', closeModalFunc);
    closeModal.addEventListener('click', closeModalFunc);
  }

  function openModal() {
    modalDialog.setAttribute('open', '');
  }

  function closeModalFunc() {
    modalDialog.removeAttribute('open');
  }
}

function showVariantGroup(sectionId, groupId) {
  const container = document.getElementById('variant-picker-' + sectionId);
  if (!container) return;
  saveActiveTab(sectionId, groupId);
  const groups = container.querySelectorAll('[data-group-content]');
  groups.forEach(group => {
    group.classList.remove('active');
  });
  const targetGroup = container.querySelector('[data-group-content="' + groupId + '"]');
  if (targetGroup) {
    targetGroup.classList.add('active');
    

    const selectedInput = targetGroup.querySelector('input[type="radio"]:checked:not(.disabled)');
    if (!selectedInput) {
      const firstAvailableInput = targetGroup.querySelector('input[type="radio"]:not(.disabled)');
      if (firstAvailableInput) {
        firstAvailableInput.checked = true;
        const event = new Event('change', { bubbles: true });
        firstAvailableInput.dispatchEvent(event);
      }
    }
  }
  const tabs = container.querySelectorAll('[data-group-tab]');
  tabs.forEach(tab => {
    tab.classList.remove('active');
    if (tab.getAttribute('data-group-tab') === groupId) {
      tab.classList.add('active');
    }
  });
  
  initPopupFunctionality();
}

function initVariantPickers() {
  const pickers = document.querySelectorAll('[data-variant-picker]');
  pickers.forEach(picker => {
    const sectionId = picker.id.replace('variant-picker-', '');
    const activeTabId = getActiveTab(sectionId);
    if (activeTabId) {
      showVariantGroup(sectionId, activeTabId);
    }
    

    const inputs = picker.querySelectorAll('input[type="radio"]');
    let hasChecked = false;
    inputs.forEach(input => {
      if (input.checked) {
        hasChecked = true;
      }
    });
    
    if (!hasChecked && inputs.length > 0) {
      for (let i = 0; i < inputs.length; i++) {
        if (!inputs[i].disabled) {
          inputs[i].checked = true;
          break;
        }
      }
    }
    

    const tabs = picker.querySelectorAll('[data-group-tab]');
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const groupId = tab.getAttribute('data-group-tab');
        if (groupId) {
          showVariantGroup(sectionId, groupId);
        }
      });
    });
  });
  
 
  initPopupFunctionality();
}

document.addEventListener('DOMContentLoaded', initVariantPickers);
document.addEventListener('shopify:section:load', initVariantPickers);

const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      for (let i = 0; i < mutation.addedNodes.length; i++) {
        const node = mutation.addedNodes[i];
        if (node.nodeType === 1 && (node.matches('[data-variant-picker]') || node.querySelector('[data-variant-picker]'))) {
          setTimeout(initVariantPickers, 10);
          break;
        }
      }
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener('submit', function(e) {
  if (e.target && e.target.id === '{{ product_form_id }}') {
    const pickers = document.querySelectorAll('[data-variant-picker]');
    pickers.forEach(picker => {
      const sectionId = picker.id.replace('variant-picker-', '');
      const activeTab = picker.querySelector('[data-group-tab].active');
      if (activeTab) {
        saveActiveTab(sectionId, activeTab.getAttribute('data-group-tab'));
      }
    });
  }
});